import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../../shared/api/firebase/references";
import { EmailOption } from "../types";

interface UseEmailOptionsProps {
  isOpen: boolean;
  isEditMode: boolean;
}

/**
 * Fetches the list of OTP-inbox email addresses from Firestore. The fetch
 * fires whenever the modal is opened or the mode toggles between add/edit
 * so the dropdown reflects the latest configured inboxes.
 *
 * Errors are logged but never rethrown — a network blip leaves the
 * dropdown empty rather than crashing the modal.
 */
export const useEmailOptions = ({
  isOpen,
  isEditMode,
}: UseEmailOptionsProps) => {
  const [modalEmailOptions, setModalEmailOptions] = useState<string[]>([]);

  useEffect(() => {
    const fetchEmailOptions = async () => {
      try {
        const emailOptions = await FirestoreService.getAllDocuments(
          FirestoreCollectionReference.emailOptions(),
        );
        const emailOptionsData = emailOptions as EmailOption[];
        const allEmails = emailOptionsData.map((option) => option.email);
        setModalEmailOptions(allEmails);
      } catch (error) {
        console.error("Error fetching email options:", error);
      }
    };
    fetchEmailOptions();
  }, [isOpen, isEditMode]);

  return { modalEmailOptions };
};
